export const YouTubeIcon = ({ width = 27, height = 27, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 27 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <g clipPath='url(#clip0_255_5894)'>
      <rect x='8.08398' y='8.08334' width='13' height='11.9167' fill='white' />
      <path
        d='M21.1001 4.30096H5.89987C2.9176 4.30096 0.5 6.71856 0.5 9.70083V17.2994C0.5 20.2816 2.9176 22.6992 5.89987 22.6992H21.1001C24.0824 22.6992 26.5 20.2816 26.5 17.2994V9.70083C26.5 6.71856 24.0824 4.30096 21.1001 4.30096ZM17.4482 13.8698L10.3386 17.2607C10.1491 17.351 9.93031 17.2129 9.93031 17.003V10.0093C9.93031 9.79648 10.1549 9.65853 10.3447 9.75475L17.4544 13.3576C17.6658 13.4647 17.6621 13.7678 17.4482 13.8698Z'
        fill='#F61C0D'
      />
    </g>
    <defs>
      <clipPath id='clip0_255_5894'>
        <rect
          width='26'
          height='26'
          fill='white'
          transform='translate(0.5 0.5)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const SoundWaveIcon = ({ width = 26, height = 20, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 26 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M4.82463 3.60899C6.12695 2.03042 6.23219 1.72786 5.65338 1.1622C5.4429 0.938572 5.19296 0.833334 4.8904 0.833334C4.52207 0.833334 4.32475 0.96488 3.71963 1.59631C2.41731 2.96441 1.37808 4.85869 0.82558 6.89768C0.391473 8.50256 0.391473 11.5808 0.82558 13.1857C1.37808 15.2246 2.41731 17.1189 3.71963 18.487C4.32475 19.1185 4.52207 19.25 4.8904 19.25C5.42975 19.25 5.98225 18.7633 5.98225 18.2897C5.98225 17.9608 5.77177 17.6188 4.82463 16.4743C4.07481 15.5667 3.27237 13.9486 2.93034 12.6858C2.54885 11.2651 2.54885 8.79197 2.93034 7.39756C3.27237 6.12155 4.07481 4.51667 4.82463 3.60899Z'
      fill='white'
    />
    <path
      d='M25.3461 6.89768C24.7936 4.85869 23.7543 2.96441 22.452 1.59631C21.8469 0.96488 21.6496 0.833334 21.2812 0.833334C20.7419 0.833334 20.1894 1.32006 20.1894 1.79363C20.1894 2.1225 20.3999 2.46452 21.347 3.60899C22.0968 4.51667 22.8993 6.1347 23.2413 7.39756C23.6228 8.80512 23.6228 11.2782 23.2413 12.6858C22.8993 13.9486 22.0968 15.5667 21.347 16.4743C20.3999 17.6188 20.1894 17.9608 20.1894 18.2897C20.1894 18.7633 20.7419 19.25 21.2812 19.25C21.6496 19.25 21.8469 19.1185 22.452 18.487C23.7543 17.1189 24.7936 15.2246 25.3461 13.1857C25.7802 11.5808 25.7802 8.50256 25.3461 6.89768Z'
      fill='white'
    />
    <path
      d='M8.69213 5.4375C9.04731 4.93762 9.03415 4.50351 8.63951 4.09571C8.52112 3.96417 8.23171 3.83262 8.00808 3.78C7.66606 3.71423 7.5082 3.78 7.11356 4.13518C6.1138 5.00339 5.21927 6.64774 4.86409 8.25262C4.27213 10.9362 5.21927 14.238 7.06094 15.8955C7.5082 16.3033 7.6529 16.3691 8.00808 16.3033C8.88945 16.1192 9.20516 15.3562 8.69213 14.6458C7.11356 12.4753 6.86362 11.8307 6.86362 10.0417C6.86362 8.25262 7.11356 7.60804 8.69213 5.4375Z'
      fill='white'
    />
    <path
      d='M21.3207 11.8044C21.8995 9.17345 20.9392 5.83214 19.137 4.20095C18.8476 3.93786 18.5056 3.72738 18.374 3.72738C17.7295 3.74054 17.0586 4.50351 17.2296 5.04286C17.269 5.17441 17.5453 5.5822 17.8347 5.92423C19.0318 7.3581 19.5711 9.25238 19.2817 10.9888C19.0975 12.0807 18.5582 13.304 17.9136 14.0539C17.3085 14.7774 17.1375 15.1063 17.2427 15.4877C17.348 15.9218 17.6768 16.1981 18.203 16.3033C18.5845 16.3823 18.6897 16.3296 19.3212 15.6719C20.1762 14.7905 21.005 13.1725 21.3207 11.8044Z'
      fill='white'
    />
    <path
      d='M15.7825 8.38417C15.5326 7.98952 15.138 7.59488 14.7433 7.3581C13.8093 6.77929 12.6386 6.72667 11.6651 7.22655C9.4551 8.33155 9.33671 11.4361 11.4283 12.7384C12.0071 13.0936 12.1913 13.133 13.0858 13.133C13.9803 13.133 14.1645 13.0936 14.7433 12.7384C15.138 12.4885 15.5326 12.0938 15.7825 11.6992C16.1377 11.1204 16.1772 10.9362 16.1772 10.0417C16.1772 9.14714 16.1377 8.96298 15.7825 8.38417Z'
      fill='white'
    />
  </svg>
);

export const SoundWaveBlueIcon = ({
  width = 26,
  height = 26,
  className = '',
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 27 26'
    fill='none'
    className={className}
  >
    <g clipPath='url(#clip0_236_28617)'>
      <rect width='26' height='26' transform='translate(0.5)' fill='white' />
      <path
        d='M4.82438 7.10899C6.12671 5.53042 6.23194 5.22786 5.65313 4.6622C5.44266 4.43857 5.19272 4.33333 4.89016 4.33333C4.52182 4.33333 4.3245 4.46488 3.71938 5.09631C2.41706 6.46441 1.37784 8.35869 0.825336 10.3977C0.391229 12.0026 0.391229 15.0808 0.825336 16.6857C1.37784 18.7246 2.41706 20.6189 3.71938 21.987C4.3245 22.6185 4.52182 22.75 4.89016 22.75C5.4295 22.75 5.982 22.2633 5.982 21.7897C5.982 21.4608 5.77153 21.1188 4.82438 19.9743C4.07456 19.0667 3.27212 17.4486 2.9301 16.1858C2.54861 14.7651 2.54861 12.292 2.9301 10.8976C3.27212 9.62155 4.07456 8.01667 4.82438 7.10899Z'
        fill='#4674B9'
      />
      <path
        d='M25.3458 10.3977C24.7933 8.35869 23.7541 6.46441 22.4518 5.09631C21.8466 4.46488 21.6493 4.33333 21.281 4.33333C20.7416 4.33333 20.1891 4.82006 20.1891 5.29363C20.1891 5.6225 20.3996 5.96452 21.3468 7.10899C22.0966 8.01667 22.899 9.6347 23.241 10.8976C23.6225 12.3051 23.6225 14.7782 23.241 16.1858C22.899 17.4486 22.0966 19.0667 21.3468 19.9743C20.3996 21.1188 20.1891 21.4608 20.1891 21.7897C20.1891 22.2633 20.7416 22.75 21.281 22.75C21.6493 22.75 21.8466 22.6185 22.4518 21.987C23.7541 20.6189 24.7933 18.7246 25.3458 16.6857C25.7799 15.0808 25.7799 12.0026 25.3458 10.3977Z'
        fill='#4674B9'
      />
      <path
        d='M8.69188 8.9375C9.04706 8.43762 9.03391 8.00351 8.63927 7.59571C8.52087 7.46417 8.23147 7.33262 8.00784 7.28C7.66581 7.21423 7.50796 7.28 7.11331 7.63518C6.11355 8.50339 5.21903 10.1477 4.86385 11.7526C4.27188 14.4362 5.21903 17.738 7.06069 19.3955C7.50796 19.8033 7.65266 19.8691 8.00784 19.8033C8.88921 19.6192 9.20492 18.8562 8.69188 18.1458C7.11331 15.9753 6.86337 15.3307 6.86337 13.5417C6.86337 11.7526 7.11331 11.108 8.69188 8.9375Z'
        fill='#4674B9'
      />
      <path
        d='M21.3205 15.3044C21.8993 12.6735 20.939 9.33214 19.1368 7.70095C18.8474 7.43786 18.5053 7.22738 18.3738 7.22738C17.7292 7.24054 17.0583 8.00351 17.2293 8.54286C17.2688 8.67441 17.545 9.0822 17.8344 9.42423C19.0315 10.8581 19.5709 12.7524 19.2815 14.4888C19.0973 15.5807 18.558 16.804 17.9134 17.5539C17.3083 18.2774 17.1372 18.6063 17.2425 18.9877C17.3477 19.4218 17.6766 19.6981 18.2028 19.8033C18.5843 19.8823 18.6895 19.8296 19.3209 19.1719C20.176 18.2905 21.0047 16.6725 21.3205 15.3044Z'
        fill='#4674B9'
      />
      <path
        d='M15.7823 11.8842C15.5324 11.4895 15.1377 11.0949 14.7431 10.8581C13.8091 10.2793 12.6383 10.2267 11.6649 10.7265C9.45486 11.8315 9.33647 14.9361 11.4281 16.2384C12.0069 16.5936 12.191 16.633 13.0856 16.633C13.9801 16.633 14.1643 16.5936 14.7431 16.2384C15.1377 15.9885 15.5324 15.5938 15.7823 15.1992C16.1375 14.6204 16.1769 14.4362 16.1769 13.5417C16.1769 12.6471 16.1375 12.463 15.7823 11.8842Z'
        fill='#4674B9'
      />
    </g>
    <defs>
      <clipPath id='clip0_236_28617'>
        <rect width='26' height='26' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);

export const BackArrowIcon = ({ width = 11, height = 18, className = '' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 11 18'
    fill='none'
    className={className}
  >
    <path
      d='M8.82934 0.250002C9.36687 0.250002 9.90478 0.44812 10.3251 0.846641C11.1938 1.67182 11.2284 3.04459 10.4027 3.91274L5.54592 9.01518L10.3978 14.0822C11.2265 14.9474 11.1961 16.3201 10.3296 17.1484C9.4628 17.9766 8.0889 17.9458 7.26015 17.0803L0.976916 10.5195C0.175951 9.68293 0.174428 8.3653 0.971966 7.52605L7.25482 0.924216C7.68233 0.476641 8.2545 0.250002 8.82934 0.250002Z'
      fill='#4674B9'
    />
  </svg>
);

export const InfoIcon = ({ width = 24, height = 24, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M19.8196 18.1464C21.27 16.3838 22.145 14.1229 22.1538 11.6562C22.174 6.0319 17.5802 1.38452 11.9998 1.38464C6.41648 1.38477 1.88578 5.9267 1.84645 11.5446C1.80711 17.1625 6.31984 21.7938 11.8938 21.8514C12.8191 21.861 13.7161 21.7454 14.5694 21.5209C15.0509 21.3942 15.5616 21.4601 15.9921 21.7118C16.5972 22.0654 17.2924 22.3729 17.9908 22.5765C18.726 22.791 19.3955 22.0817 19.1622 21.3471C18.9763 20.762 19.0183 20.1757 19.1207 19.6258C19.2222 19.0803 19.468 18.5737 19.8196 18.1464Z'
      fill='#F0F2FF'
    />
    <path
      d='M19.1005 21.3585C18.9153 20.7786 18.9571 20.1976 19.0591 19.6526C19.1604 19.112 19.4053 18.6099 19.7556 18.1866C20.3518 17.466 20.8501 16.6611 21.2308 15.7928C13.4023 19.8321 3.94587 12.565 8.81522 2.0769C4.79109 3.39667 1.87789 7.17678 1.84645 11.644C1.80725 17.2115 6.3039 21.8011 11.858 21.8583C12.7801 21.8677 13.6738 21.7532 14.5241 21.5307C15.0039 21.4052 15.5128 21.4705 15.9417 21.7199C16.5447 22.0703 17.2373 22.375 17.9333 22.5769C18.6658 22.7893 19.333 22.0865 19.1005 21.3585Z'
      fill='#DBE1FF'
    />
    <path
      d='M13.5088 15.6974V9.2738C13.5088 8.72451 12.9474 8.35393 12.4424 8.56981C11.8829 8.80893 11.2855 8.94676 10.6778 8.97692L9.67587 9.02662C9.44164 9.03826 9.25769 9.23155 9.25769 9.46606V10.0928C9.25769 10.3358 9.45468 10.5328 9.69767 10.5328H10.5769C10.7784 10.5328 10.9415 10.6961 10.9415 10.8975V15.6973H10.0414C9.6086 15.6973 9.25769 16.0482 9.25769 16.4811V16.8002C9.25769 17.233 9.60856 17.5839 10.0414 17.5839H14.409C14.8418 17.5839 15.1927 17.233 15.1927 16.8002V16.4811C15.1927 16.0482 14.8418 15.6973 14.409 15.6973L13.5088 15.6974Z'
      fill='#7F9AE6'
    />
    <path
      d='M12.2251 7.07397C12.934 7.07397 13.5087 6.49926 13.5087 5.79031C13.5087 5.08137 12.934 4.50665 12.2251 4.50665C11.5161 4.50665 10.9414 5.08137 10.9414 5.79031C10.9414 6.49926 11.5161 7.07397 12.2251 7.07397Z'
      fill='#7F9AE6'
    />
  </svg>
);

export const LiveStreamIcon = ({ width = 24, height = 20, className = '' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 24 20'
    fill='none'
    className={className}
  >
    <rect width='24' height='20' fill='white' />
    <path
      d='M3.99197 4.56214C5.19411 3.105 5.29125 2.82571 4.75696 2.30357C4.56268 2.09714 4.33196 2 4.05268 2C3.71268 2 3.53054 2.12143 2.97197 2.70428C1.76982 3.96714 0.810536 5.71571 0.300536 7.59786C-0.100179 9.07928 -0.100179 11.9207 0.300536 13.4021C0.810536 15.2843 1.76982 17.0329 2.97197 18.2957C3.53054 18.8786 3.71268 19 4.05268 19C4.55054 19 5.06054 18.5507 5.06054 18.1136C5.06054 17.81 4.86625 17.4943 3.99197 16.4379C3.29982 15.6 2.55911 14.1064 2.24339 12.9407C1.89125 11.6293 1.89125 9.34643 2.24339 8.05929C2.55911 6.88143 3.29982 5.4 3.99197 4.56214Z'
      fill='#4674B9'
    />
    <path
      d='M22.9348 7.59786C22.4248 5.71571 21.4655 3.96714 20.2634 2.70428C19.7048 2.12143 19.5227 2 19.1827 2C18.6848 2 18.1748 2.44928 18.1748 2.88643C18.1748 3.19 18.3691 3.50571 19.2434 4.56214C19.9355 5.4 20.6763 6.89357 20.992 8.05929C21.3441 9.35857 21.3441 11.6414 20.992 12.9407C20.6763 14.1064 19.9355 15.6 19.2434 16.4379C18.3691 17.4943 18.1748 17.81 18.1748 18.1136C18.1748 18.5507 18.6848 19 19.1827 19C19.5227 19 19.7048 18.8786 20.2634 18.2957C21.4655 17.0329 22.4248 15.2843 22.9348 13.4021C23.3355 11.9207 23.3355 9.07928 22.9348 7.59786Z'
      fill='#4674B9'
    />
    <path
      d='M7.56197 6.25C7.88982 5.78857 7.87768 5.38786 7.51339 5.01143C7.40411 4.89 7.13697 4.76857 6.93054 4.72C6.61482 4.65929 6.46911 4.72 6.10482 5.04786C5.18197 5.84929 4.35625 7.36714 4.02839 8.84857C3.48196 11.3257 4.35625 14.3736 6.05625 15.9036C6.46911 16.28 6.60268 16.3407 6.93054 16.28C7.74411 16.11 8.03554 15.4057 7.56197 14.75C6.10482 12.7464 5.87411 12.1514 5.87411 10.5C5.87411 8.84857 6.10482 8.25357 7.56197 6.25Z'
      fill='#4674B9'
    />
    <path
      d='M19.2191 12.1271C19.7534 9.69857 18.867 6.61428 17.2034 5.10857C16.9363 4.86571 16.6205 4.67143 16.4991 4.67143C15.9041 4.68357 15.2848 5.38786 15.4427 5.88571C15.4791 6.00714 15.7341 6.38357 16.0013 6.69929C17.1063 8.02286 17.6041 9.77143 17.337 11.3743C17.167 12.3821 16.6691 13.5114 16.0741 14.2036C15.5155 14.8714 15.3577 15.175 15.4548 15.5271C15.552 15.9279 15.8555 16.1829 16.3413 16.28C16.6934 16.3529 16.7905 16.3043 17.3734 15.6971C18.1627 14.8836 18.9277 13.39 19.2191 12.1271Z'
      fill='#4674B9'
    />
    <path
      d='M14.107 8.97C13.8763 8.60571 13.512 8.24143 13.1477 8.02286C12.2855 7.48857 11.2048 7.44 10.3063 7.90143C8.26625 8.92143 8.15696 11.7871 10.0877 12.9893C10.622 13.3171 10.792 13.3536 11.6177 13.3536C12.4434 13.3536 12.6134 13.3171 13.1477 12.9893C13.512 12.7586 13.8763 12.3943 14.107 12.03C14.4348 11.4957 14.4713 11.3257 14.4713 10.5C14.4713 9.67429 14.4348 9.50428 14.107 8.97Z'
      fill='#4674B9'
    />
  </svg>
);

export const QuestionMarkIcon = ({
  width = 41,
  height = 28,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 41 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.1742 6.35083C1.69728 6.35083 0.5 7.62915 0.5 9.20594V20.4122C0.5 21.9892 1.69728 23.2673 3.1742 23.2673H11.5536L15.7985 25.8839C16.3334 26.2135 17.0019 25.8016 17.0019 25.1422V23.2673H19.0188C20.4957 23.2673 21.693 21.9892 21.693 20.4122V9.20594C21.693 7.62915 20.4957 6.35083 19.0188 6.35083H3.1742Z'
      fill='#F49F3E'
    />
    <path
      d='M10.4472 16.5712C10.237 16.5712 10.0714 16.4976 9.95013 16.3499C9.82889 16.2023 9.76831 16.0071 9.76831 15.7639C9.76831 15.4251 9.82889 15.1083 9.95013 14.813C10.0714 14.5091 10.2775 14.1966 10.5684 13.8753C10.7624 13.6583 10.8958 13.4759 10.9685 13.3283C11.0494 13.1807 11.0898 13.0244 11.0898 12.8594C11.0898 12.4513 10.823 12.2473 10.2896 12.2473C10.031 12.2473 9.78852 12.2777 9.56221 12.3385C9.33586 12.3993 9.11765 12.4904 8.9075 12.6119C8.66507 12.7422 8.45087 12.7856 8.26494 12.7422C8.0791 12.6988 7.9336 12.5989 7.82855 12.4426C7.72344 12.2864 7.66686 12.104 7.65883 11.8956C7.65073 11.6872 7.6992 11.4832 7.8043 11.2835C7.91745 11.0838 8.10332 10.9188 8.36196 10.7886C8.6933 10.6149 9.04494 10.489 9.41674 10.4109C9.78852 10.324 10.136 10.2806 10.4593 10.2806C11.017 10.2806 11.506 10.3761 11.9263 10.5672C12.3546 10.7582 12.686 11.0274 12.9204 11.3746C13.1548 11.722 13.272 12.1214 13.272 12.5729C13.272 12.9636 13.1871 13.3283 13.0174 13.667C12.8558 13.9968 12.5608 14.3312 12.1324 14.6697C11.7525 14.965 11.4979 15.2168 11.3686 15.4251C11.2474 15.6335 11.1625 15.855 11.114 16.0894C11.0816 16.2283 11.013 16.3456 10.9079 16.4411C10.8028 16.5278 10.6493 16.5712 10.4472 16.5712ZM10.4108 19.6842C10.0391 19.6842 9.74406 19.567 9.52581 19.3325C9.3157 19.0893 9.2106 18.781 9.2106 18.4077C9.2106 18.0431 9.3157 17.7434 9.52581 17.5092C9.74406 17.2745 10.0391 17.1575 10.4108 17.1575C10.7826 17.1575 11.0736 17.2745 11.2837 17.5092C11.4939 17.7434 11.5989 18.0431 11.5989 18.4077C11.5989 18.781 11.4939 19.0893 11.2837 19.3325C11.0736 19.567 10.7826 19.6842 10.4108 19.6842Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M28.8255 23.4476C35.3756 22.8917 40.5 17.9453 40.5 11.9254C40.5 5.53321 34.7221 0.351318 27.5945 0.351318C20.4672 0.351318 14.6892 5.53321 14.6892 11.9254C14.6892 17.0244 18.3659 21.3532 23.4714 22.896L24.1961 26.4163C24.3336 27.0841 25.0689 27.3357 25.5196 26.8692L28.8255 23.4476Z'
      fill='#4F95CC'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.3837 16.8295C26.8424 17.3886 25.9827 17.3811 25.45 16.807L21.986 13.074C21.4461 12.4921 21.4461 11.5487 21.986 10.9668C22.5259 10.3849 23.4013 10.3849 23.9412 10.9668L26.436 13.6551L30.9776 8.76074C31.5175 8.17888 32.393 8.17888 32.9329 8.76074C33.4728 9.34269 33.4728 10.2861 32.9329 10.8679L27.5222 16.6988C27.4781 16.7461 27.4319 16.7898 27.3837 16.8295Z'
      fill='white'
    />
    <path
      d='M0.5 9.10348C0.5 7.58323 1.73259 6.35083 3.25306 6.35083H9.48246C9.48246 6.35083 3.85967 7.14397 3.85967 14.8187C3.85967 22.4935 3.85967 23.3333 3.85967 23.3333H3.25306C1.73259 23.3333 0.5 22.1009 0.5 20.5806V9.10348Z'
      fill='#E79437'
    />
    <path
      d='M19.2852 11.8938C19.2852 19.825 23.6203 22.7838 23.6203 22.7838C20.5346 22.255 14.6892 18.2685 14.6892 11.8938C14.6892 5.51906 20.4974 0.351318 27.6622 0.351318C27.6622 0.351318 19.2852 3.96256 19.2852 11.8938Z'
      fill='#4186BB'
    />
  </svg>
);

export const SuccessBadgeIcon = ({
  width = 32,
  height = 32,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M30.1638 16.0656C30.1638 23.8882 23.8225 30.2295 15.9999 30.2295C8.17725 30.2295 1.83594 23.8882 1.83594 16.0656C1.83594 8.24293 8.17725 1.90162 15.9999 1.90162C23.8225 1.90162 30.1638 8.24293 30.1638 16.0656Z'
      fill='#65AA20'
    />
    <path
      d='M14.9125 25.5404C16.0754 24.4362 16.7868 21.4172 16.7868 21.4172L14.9125 19.8228C14.9125 19.8228 12.4137 16.8832 12.4279 16.8944C7.28589 10.9031 11.1678 2.78007 11.2116 2.6885C5.74879 4.63281 1.83594 9.85815 1.83594 15.9986C1.83594 23.2662 7.31707 29.2517 14.3628 30.0328C13.4448 28.6396 13.6541 26.7356 14.9125 25.5404Z'
      fill='#5F9E1F'
    />
    <path
      d='M14.5123 22.9508C14.0682 22.9508 13.6217 22.8102 13.2454 22.5228L7.36579 16.543C6.45795 15.85 6.28961 14.5597 6.98995 13.6611C7.69008 12.7627 8.99378 12.5961 9.90162 13.2891L14.2605 18.1081L21.4332 10.2509C22.2018 9.40896 23.5144 9.34308 24.3653 10.1041C25.2159 10.8647 25.2825 12.1641 24.5136 13.006L16.0535 22.2735C15.6455 22.7204 15.0809 22.9508 14.5123 22.9508Z'
      fill='white'
    />
  </svg>
);


export const TripleDotsIcons = ({ width = 32, height = 32, className = '' }) => (
  <svg width={width} height={height} viewBox="0 0 30 38" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
  <g filter="url(#filter0_d_2048_14736)">
  <rect width="30" height="34" rx="8" fill="#79A7EC" shapeRendering="crispEdges"/>
  <rect x="1" y="1" width="28" height="32" rx="7" stroke="#79A7EC" strokeWidth="2" shapeRendering="crispEdges"/>
  <path d="M9.62 24.1C9.08667 24.1 8.66 23.94 8.34 23.62C8.03333 23.3 7.88 22.8867 7.88 22.38C7.88 21.8867 8.03333 21.4867 8.34 21.18C8.66 20.86 9.08667 20.7 9.62 20.7C10.1533 20.7 10.5667 20.86 10.86 21.18C11.1667 21.4867 11.32 21.8867 11.32 22.38C11.32 22.8867 11.1667 23.3 10.86 23.62C10.5667 23.94 10.1533 24.1 9.62 24.1ZM14.8153 24.1C14.282 24.1 13.8553 23.94 13.5353 23.62C13.2286 23.3 13.0753 22.8867 13.0753 22.38C13.0753 21.8867 13.2286 21.4867 13.5353 21.18C13.8553 20.86 14.282 20.7 14.8153 20.7C15.3486 20.7 15.762 20.86 16.0553 21.18C16.362 21.4867 16.5153 21.8867 16.5153 22.38C16.5153 22.8867 16.362 23.3 16.0553 23.62C15.762 23.94 15.3486 24.1 14.8153 24.1ZM20.0106 24.1C19.4773 24.1 19.0506 23.94 18.7306 23.62C18.424 23.3 18.2706 22.8867 18.2706 22.38C18.2706 21.8867 18.424 21.4867 18.7306 21.18C19.0506 20.86 19.4773 20.7 20.0106 20.7C20.544 20.7 20.9573 20.86 21.2506 21.18C21.5573 21.4867 21.7106 21.8867 21.7106 22.38C21.7106 22.8867 21.5573 23.3 21.2506 23.62C20.9573 23.94 20.544 24.1 20.0106 24.1Z" fill="#F8FCFE"/>
  </g>
  <defs>
  <filter id="filter0_d_2048_14736" x="0" y="0" width="30" height="38" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="4"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.275 0 0 0 0 0.455 0 0 0 0 0.725 0 0 0 1 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2048_14736"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2048_14736" result="shape"/>
  </filter>
  </defs>
  </svg>
  
);